import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import logo from '../../..../../../../public/assets/logo.png';
import React from 'react';
import { UserRemove } from 'iconsax-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PrimaryButon } from '../../components/common/button/PrimaryButon';
import { black400 } from '../../constants/color';
import { centered } from '../freelancer/account/style';
import { useAppDispatch } from '@application/store/useStore';
import { regenerateEmailLinkAsync } from '@application/features/auth/authThunks';
export const EmailVerificationCodeExpired = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [searchParams] = useSearchParams();
    const candidateId = searchParams.get('userId');
    const userId = candidateId && /^[a-zA-Z0-9-]+$/.test(candidateId) ? candidateId : undefined;
    const generateNewLink = () => {
        if (userId)
            dispatch(regenerateEmailLinkAsync(userId))
                .unwrap()
                .then((response) => {
                if (response)
                    navigate('/login');
            }).catch(() => { });
    };
    return (_jsx(Box, { sx: { ...centered, height: '100vh' }, children: _jsxs(Box, { sx: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '550px',
                textAlign: 'center'
            }, children: [_jsx("img", { src: logo, alt: '', style: { width: 150, height: "auto" } }), _jsx(UserRemove, { style: { width: '50px', height: '50px', marginTop: '45px' } }), _jsx(Typography, { fontSize: '28px', fontWeight: 550, mt: 2, color: '#000000', children: "Account Verification Link Expired" }), _jsx(Typography, { variant: 'subtitle1', color: black400, children: "Your account verification link has expired" }), _jsx(Typography, { variant: 'subtitle1', color: black400, children: "Please request a new link to complete your login process." }), _jsx(Box, { px: 3, width: '70%', children: _jsx(PrimaryButon, { onClick: userId ? generateNewLink : () => navigate('/login'), mt: 25, children: userId ? 'Request new link' : 'Back to sign in' }) })] }) }));
};
